import React from 'react';
import { Box, Chip, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { brandColors } from '../../theme';

export type MediaItem = {
  id: string;
  type: 'image' | 'video';
  src: string;
  alt?: string;
};

export type ContentPost = {
  id: string;
  title?: string;
  text: string;
  platforms: Array<'instagram' | 'facebook'>;
  media: MediaItem[]; // for carousel provide multiple items
};

interface PostPreviewProps {
  open: boolean;
  post: ContentPost | null;
  onClose: () => void;
}

const PostPreview: React.FC<PostPreviewProps> = ({ open, post, onClose }) => {
  if (!post) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {post.title || 'Post Vorschau'}
        </Typography>
        <Stack direction="row" spacing={1}>
          {post.platforms.map((p) => (
            <Chip
              key={p}
              label={p === 'instagram' ? 'Instagram' : 'Facebook'}
              size="small"
              sx={{
                bgcolor: p === 'instagram' ? `${brandColors.electricTeal}20` : `${brandColors.neonLime}20`,
                color: p === 'instagram' ? brandColors.electricTeal : brandColors.midnightSteel,
                border: '1px solid',
                borderColor: p === 'instagram' ? `${brandColors.electricTeal}50` : `${brandColors.midnightSteel}40`,
                fontWeight: 600,
              }}
            />
          ))}
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {post.media.length > 0 && (
            <Box sx={{
              display: 'grid',
              gap: 1,
              gridTemplateColumns: post.media.length > 1 ? 'repeat(2, 1fr)' : '1fr',
            }}>
              {post.media.map((m) => (
                <Box key={m.id} sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden', border: `1px solid ${brandColors.midnightSteel}10` }}>
                  {m.type === 'image' ? (
                    <img src={m.src} alt={m.alt || 'Post media'} style={{ width: '100%', display: 'block' }} />
                  ) : (
                    <video src={m.src} controls style={{ width: '100%', display: 'block' }} />
                  )}
                </Box>
              ))}
            </Box>
          )}
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {post.text}
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default PostPreview;




